import { useEffect, useState, useRef } from 'react'
import './profileView.css'
import FlexComponent from '../../components/FlexComponent'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom/dist'
import axios from '../../utils/axios'
import { getAppLead, AddFollowers, AddSales, MoveToFollower, MoveToSales, RemoveFollowerSales, updateAssignedUser, auditLog, UpdateLeadStage, appKanbanUserList, appSubmission, getCustomFields } from '../../utils/urls'
import PersonalInformation from '../../components/profileView/PersonalInformation'
import Applicant from '../../components/profileView/Applicant'
import WorkExperience from '../../components/profileView/WorkExperience'
import Address from '../../components/profileView/Address'
import ShoppingFor from '../../components/profileView/ShoppingFor'
import TypeOfHome from '../../components/profileView/TypeOfHome'
import SavingsAndAssets from '../../components/profileView/SavingsAndAssets'
import PropertyOwned from '../../components/profileView/PropertyOwned'
import { Toast } from 'primereact/toast';
import FormSubmissionList from '../../components/profileView/FormSubmissionList'
import CoSigner from '../../components/profileView/CoSigner'
import AuditLogs from '../../components/profileView/AuditLogs'
import Activity from '../../components/apps/appsKanban/Activity'
// import Activity from '../../components/profileView/Activity'
import adminLogo from '../../Images/admin_img.jpg'
import AllSubmissionData from '../../components/profileView/AllSubmissionData'
import { ProgressSpinner } from 'primereact/progressspinner'
import { WorkingOnBanner } from '../../components/apps/workingOn/WorkingOn'


function ProfileView() {
    const toast = useRef(null);
    const { contactId, formId } = useParams();
    const url = `${getAppLead}${contactId}/${formId}`
    const isSuperuser = useSelector((state) => state.user.isSuperuser);
    const image = useSelector((state) => state.user.image);
    const userId = useSelector((state) => state.user.userId);
    const [profileData, setProfileData] = useState(null)
    const [applicantData, setApplicantData] = useState(null);
    const [applicantDetail, setApplicantDetails] = useState(null);
    const [allCustomFields, setAllCustomFields] = useState([])

    const [usersList, setUsersList] = useState([])
    const [workData, setWorkData] = useState(null);
    const [addressData, setAddressData] = useState(null);
    const [cosignerData, setCosignerData] = useState(null);
    const [shoppingData, setShoppingData] = useState(null);
    const [typeOfHomeData, setTypeOfHomeData] = useState(null);
    const [savingsData, setSavingsData] = useState(null);
    const [propertyData, setPropertyData] = useState(null);
    const [notes, setNotes] = useState(null);
    const [formList, setFormList] = useState(null);
    const [fullFormList, setFullFormList] = useState(null)
    const [isMounted, setIsMounted] = useState(false)
    const [loading, setLoading] = useState(true)
    const [memberLoading, setMemberLoading] = useState(false)
    const [isSubmit, setIsSubmit] = useState(false)
    const [auditLogs, setAuditLogs] = useState()

    const auditLogsFn = async () => {
        const auditUrl = `${auditLog}${formId}`
        axios.get(auditUrl, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    // console.log(response.data.audit_log)
                    setAuditLogs(response.data.audit_log)
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                // setLoading(false)
            })
    }

    const loadUsersData = () => {
        if (userId) {
            const url = `${appKanbanUserList}?userId=${userId}`
            axios.get(url, {
                headers: { 'Content-Type': 'application/json' }
            })
                .then((response) => {
                    if (response.status === 200) {
                        // console.log(response.data)
                        const options = response?.data?.map((user) => ({
                            label: user.name,
                            value: user.user_id,
                            image: user.image
                        })) || [];
                        setUsersList(options)
                    }
                })
                .catch((error) => {
                    // setAppLeads(null)
                })
        }
    }

    const getAllCustomFields = () => {
        const listUrl = `${getCustomFields}`
        axios.get(listUrl, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    // console.log(response.data)
                    setAllCustomFields(response.data)
                }
            })
            .catch((error) => {
                // setAppLeads(null)
            })
    }

    const getApplicantData = () => {
        const url = `${appSubmission}${formId}?pipelineId=1`
        axios.get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    // console.log(response.data)
                    const data = response.data
                    setApplicantDetails(data)
                }
            })
            .catch((error) => {
                // setAppLeads(null)
            })
    }



    useEffect(() => {
        // setLoading(true);
        auditLogsFn()
        loadUsersData()
        getAllCustomFields()
        getApplicantData()
        axios.get(url, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    console.log(response.data)
                    setProfileData(response.data.personal_data)
                    setApplicantData(response.data.applicant_data)
                    setWorkData(response.data.work_experience_data)
                    setAddressData(response.data.address_data)
                    setShoppingData(response.data.shopping_data)
                    setTypeOfHomeData(response.data.type_of_home_data)
                    setSavingsData(response.data.savings_assets_data)
                    setPropertyData(response.data.property_owned_data)
                    setFormList(response.data.form_list)
                    setFullFormList(response.data.full_custom_form_data)
                    setCosignerData(response.data.cosigner_list)
                    setNotes(response.data.notes)
                }
                setLoading(false)
                setIsSubmit(false)
            })
            .catch((error) => {
                setProfileData(null)
                setApplicantData(null)
                setWorkData(null)
                setAddressData(null)
                setShoppingData(null)
                setTypeOfHomeData(null)
                setSavingsData(null)
                setPropertyData(null)
                setFormList(null)
                setCosignerData(null)
                setIsSubmit(false)
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                // setLoading(false)
            })
    }, [url, isMounted, isSubmit, userId])

    const handleStageUpdate = (contact_id, form_id, stage, stageId, emails = []) => {
        const data = {
            stage_id: stageId,
            userId: userId,
            email_list: emails
        }
        const stageUrl = `${UpdateLeadStage}${contact_id}/${form_id}`
        axios.post(stageUrl, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setIsMounted(!isMounted)
                    setIsSubmit(!isSubmit)
                }
                else if (response.status === 208) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.data, life: 3000 });
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });

            })
    }

    const AddLeadFollowers = (selectedUsers) => {
        const data = {
            selectedUsers,
            userId: userId,
            app_id: formId
        }
        const Url = `${AddFollowers}${contactId}`
        axios.post(Url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setIsMounted(!isMounted)
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });

            })
    }



    const AddLeadSales = (selectedUsers) => {
        const data = {
            selectedUsers,
            userId: userId,
            app_id: formId
        }
        const Url = `${AddSales}${contactId}`
        axios.post(Url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setIsMounted(!isMounted)
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });

            })
    }

    const MoveLeadSalesToFollower = (user) => {
        const data = {
            user,
            userId: userId,
            app_id: formId
        }
        const Url = `${MoveToFollower}${contactId}`
        axios.post(Url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setIsMounted(!isMounted)
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });

            })
    }

    const MoveLeadFollowerToSales = (user) => {
        const data = {
            user,
            userId: userId,
            app_id: formId
        }
        const Url = `${MoveToSales}${contactId}`
        axios.post(Url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setIsMounted(!isMounted)
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });

            })
    }

    const RemoveLeadFollowerSales = (user) => {
        const data = {
            user,
            userId: userId,
            app_id: formId
        }
        const Url = `${RemoveFollowerSales}${contactId}`
        axios.post(Url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setIsMounted(!isMounted)
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });

            })
    }

    const updateContactOpportunityOwner = (user) => {
        console.log(user)
        setMemberLoading(true)
        const data = {
            user,
            userId: userId,
            app_id: formId
        }
        const Url = `${updateAssignedUser}${contactId}`
        axios.post(Url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setIsMounted(!isMounted)
                    setMemberLoading(false)
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });

            })
    }

    return (
        <div>
            <Toast ref={toast} />
            <div
                className='table-container'
                style={{
                    paddingBottom: '2rem',
                    backgroundImage: `url("${isSuperuser ? adminLogo : image}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    minHeight: '90vh',
                    position: 'relative' // Needed for overlay positioning
                }}
            >
                <div
                    className='table-inner-div'
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 0 // Below content
                    }}
                />
                {applicantDetail && (
                    <div style={{ position: 'relative', zIndex: 1, padding: '1rem 2rem 0' }}>
                        <WorkingOnBanner app={applicantDetail} toast={toast} />
                    </div>
                )}
                <FlexComponent>
                    {!loading &&
                        <div key={isSubmit}>
                            <FlexComponent  className='profileContainer' justifyContent='center' alignItems='start' style={{  gap: '2rem' }}  >
                                <FlexComponent className='profileViewDivs' flexDirection='column' style={{ gap: '2rem', width: '35%', zIndex: '1' }}>
                                    <FlexComponent flexDirection="column" alignItems="start" className="profileViewContainer" style={{ borderRadius: '1rem' }}>
                                        <FlexComponent justifyContent="start" >
                                            {formList?.length > 1 && <FormSubmissionList data={formList} formId={formId} />}
                                            {auditLogs?.length > 1 && <AuditLogs data={auditLogs} formId={formId} />}
                                        </FlexComponent >
                                        <div style={{ width: "100%", marginTop: (formList?.length > 1 || auditLogs?.length > 1) && "-75px" }} >
                                            {applicantData && <Applicant data={applicantData} applicantData={applicantDetail} allCustomFields={allCustomFields} setIsSubmit={setIsSubmit} isSubmit={isSubmit} handleStageUpdate={handleStageUpdate} contactId={contactId} formId={formId} userId={userId} AddLeadFollowers={AddLeadFollowers} AddLeadSales={AddLeadSales} MoveLeadSalesToFollower={MoveLeadSalesToFollower} MoveLeadFollowerToSales={MoveLeadFollowerToSales} RemoveLeadFollowerSales={RemoveLeadFollowerSales} memberLoading={memberLoading} updateContactOpportunityOwner={updateContactOpportunityOwner} toast={toast} />}
                                        </div> 
                                    </FlexComponent>
                                    <WorkExperience data={workData} setIsSubmit={setIsSubmit} formId={formId} userId={userId} toast={toast} />
                                    {profileData && <PersonalInformation data={profileData} setIsSubmit={setIsSubmit} formId={formId} userId={userId} toast={toast} />}
                                    {addressData.length > 0 && <Address data={addressData} setIsSubmit={setIsSubmit} formId={formId} userId={userId} toast={toast} />}
                                    <PropertyOwned data={propertyData} setIsSubmit={setIsSubmit} formId={formId} userId={userId} toast={toast} />

                                </FlexComponent>
                                {/* //////////////////////////////////////////////////////////////////// */}
                                <FlexComponent className='profileViewDivs' flexDirection='column' style={{ gap: '2rem', width: '50%', zIndex: '0' }}>
                                    <div className='profileActivityContainer' style={{ width: "100%", borderRadius: '1rem', paddingBottom: "20px" }} >
                                        <div style={{ textAlign: 'start', width: '100%', padding: '1rem 1.5rem' }}>
                                            <p style={{ fontWeight: '600' }}>Activity</p>
                                        </div>
                                        {notes && <div style={{ maxHeight: "450px", overflowY: "auto", padding: "1.5rem" }} >
                                            <Activity comments={notes} contacts={applicantData?.contacts} usersList={usersList} formId={formId} userId={userId} section="profileView" />
                                        </div>}
                                    </div>
                                    {shoppingData && <ShoppingFor data={shoppingData} setIsSubmit={setIsSubmit} formId={formId} userId={userId} toast={toast} />}
                                    {typeOfHomeData && <TypeOfHome data={typeOfHomeData} setIsSubmit={setIsSubmit} formId={formId} userId={userId} toast={toast} />}
                                    {savingsData && <SavingsAndAssets data={savingsData} setIsSubmit={setIsSubmit} formId={formId} userId={userId} toast={toast} />}
                                    {/* {cosignerData?.do_you_have_a_cosigner && <CoSigner  data={cosignerData} setIsSubmit={setIsSubmit} formId={formId} userId={userId} toast={toast}/>} */}
                                    {<CoSigner data={cosignerData.cosigners} locationId={applicantData?.location_id} isCosigner={cosignerData?.do_you_have_a_cosigner} setIsSubmit={setIsSubmit} formId={formId} userId={userId} toast={toast} />}
                                </FlexComponent>
                            </FlexComponent>
                            {isSuperuser && <AllSubmissionData data={fullFormList} />}
                        </div>
                    }
                    {loading && <ProgressSpinner />}


                </FlexComponent>
            </div>
        </div>
    )
}

export default ProfileView
